import {
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TableHeader,
  TableRow,
} from '@sandtech-hub-monorepo/ui-kit';
import { TranscriptCourse } from '../utils';

interface Props {
  courses: TranscriptCourse[];
}

/**
 * Transfer / prior credit section: courses earned without a class attempt
 * (e.g. ALX equivalated courses). Grade 'T', earned credits only, GPA-neutral.
 */
const TransferTable = ({ courses }: Props) => {
  const earnedCredits = courses.reduce((sum, c) => sum + c.earnedCredits, 0);

  return (
    <div className="w-full border border-muted rounded-md overflow-hidden print:overflow-visible print:break-inside-avoid">
      <div className="flex items-center justify-between px-3 py-2 text-xs md:text-sm bg-muted/30">
        <p className="font-semibold text-foreground">Transfer Credit</p>
        <p className="font-medium text-muted-foreground">
          <span className="hidden sm:inline">Total credits earned: </span>
          <span className="sm:hidden">Credits: </span>
          {earnedCredits}
        </p>
      </div>

      <Table>
        <TableHeader>
          <TableRow className="border-muted">
            <TableHead className="whitespace-nowrap font-normal sm:text-xs">
              Course
            </TableHead>
            <TableHead className="hidden md:table-cell print:table-cell w-full font-normal sm:text-xs">
              Course Title
            </TableHead>
            <TableHead className="text-center whitespace-nowrap leading-tight font-normal sm:text-xs">
              Credits
              <br />
              Earned
            </TableHead>
            <TableHead className="text-center whitespace-nowrap font-normal sm:text-xs">
              Grade
            </TableHead>
            <TableHead className="text-center whitespace-nowrap leading-tight font-normal sm:text-xs">
              GPA
              <br />
              Points
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {courses.map((course, i) => (
            <TableRow key={i} className="border-muted">
              <TableCell className="text-foreground">
                {course.abbreviation}
              </TableCell>
              <TableCell className="hidden md:table-cell print:table-cell text-foreground">
                {course.name}
              </TableCell>
              <TableCell className="text-center text-foreground">
                {course.earnedCredits}
              </TableCell>
              <TableCell className="text-center font-medium text-foreground">
                {course.grade ?? 'T'}
              </TableCell>
              <TableCell className="text-center text-muted-foreground">
                —
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
        <TableFooter className="bg-muted/30 border-muted/50">
          <TableRow>
            <TableCell className="font-semibold text-foreground">
              Totals
            </TableCell>
            <TableCell className="hidden md:table-cell print:table-cell" />
            <TableCell className="text-center font-medium text-foreground">
              {earnedCredits}
            </TableCell>
            <TableCell colSpan={2} />
          </TableRow>
        </TableFooter>
      </Table>
    </div>
  );
};

export default TransferTable;
